<header class="header">
  <h1 class="h1">{{ title }}</h1>

  <div class="header-username-wrapper">
    <img src="assets/icons/circled-user.svg" class="header-icon" />
    <div *ngIf="isClientFullNameLoading; else clientFullNameLabel" class="skeleton header-username-skeleton"></div>
    <ng-template #clientFullNameLabel>
      <p class="header-username">{{ clientFullName }}</p>
    </ng-template>
  </div>
</header>
